import Siema from 'siema';

document.addEventListener('DOMContentLoaded',function() {

    let el = document.getElementsByClassName('js-postcarousel--text')[0];
    
    const init = function() {
        const textSiema = new Siema({
            selector: '.js-postcarousel--text',
            duration: 400,
            loop: true,
            onChange: () => {
                
            }
        });
    
        const imageSiema = new Siema({
            selector: '.js-postcarousel--images',
            duration: 400,
            loop: true,
            onChange: () => {
                textSiema.next()
            }
        });
        
        let loop = setInterval(function() {
            imageSiema.next();
        }, 5500)
        
        
        document.querySelector('.js-postcarousel--next').addEventListener('click', function() {
            
            clearInterval(loop);
            imageSiema.next();
            
        });

        document.querySelector('.js-postcarousel--prev').addEventListener('click', function() {
            
            clearInterval(loop);
            imageSiema.prev();
            
        });
    }
    
    
    el ? init() : false;
    
    
}, false);

